import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Modal.css';

function EventInfoModal({ onClose, onSuccess }) {
  const [eventTitle, setEventTitle] = useState('');
  const [eventLogoUrl, setEventLogoUrl] = useState('');
  const [newEventTitle, setNewEventTitle] = useState('');
  const [logoFile, setLogoFile] = useState(null);
  const [adminPassword, setAdminPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  useEffect(() => {
    const fetchEventInfo = async () => {
      try {
        const response = await api.get('/settings/event-info');
        setEventTitle(response.data.event_title || '');
        setEventLogoUrl(response.data.event_logo_url || '');
        setNewEventTitle(response.data.event_title || '');
      } catch (error) {
        console.error('Error fetching event info:', error);
      }
    };
    fetchEventInfo();
  }, []);

  const handleUpdateEventInfo = async () => {
    if (!adminPassword) {
      setMessage('Please enter admin password.');
      setMessageType('error');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('password', adminPassword);

      if (newEventTitle !== eventTitle) {
        formData.append('event_title', newEventTitle);
      }

      if (logoFile) {
        formData.append('logo', logoFile);
      }

      await api.post('/settings/event-info', formData);
      setMessage('Event info updated successfully.');
      setMessageType('success');
      if (onSuccess) onSuccess();
      setTimeout(() => onClose(), 1200);
    } catch (error) {
      setMessage(error.response?.data?.detail || 'Error updating event info.');
      setMessageType('error');
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <h2>Update Event Information</h2>

        <div className="form-group">
          <label>Event Title:</label>
          <input
            type="text"
            name="event-title"
            autoComplete="off"
            value={newEventTitle}
            onChange={(e) => setNewEventTitle(e.target.value)}
            placeholder="Enter event title"
            autoFocus
          />
        </div>

        <div className="form-group">
          <label>Event Logo:</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setLogoFile(e.target.files[0])}
          />
          {eventLogoUrl && (
            <div style={{ marginTop: '10px' }}>
              <p style={{ fontSize: '0.9em', color: '#666' }}>Current logo:</p>
              <img src={eventLogoUrl} alt="Event logo" style={{ maxWidth: '200px', maxHeight: '100px' }} />
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Admin Password:</label>
          <input
            type="password"
            name="admin-password"
            autoComplete="new-password"
            value={adminPassword}
            onChange={(e) => { setAdminPassword(e.target.value); setMessage(''); }}
            placeholder="Enter admin password"
          />
        </div>

        {message && <p className={`modal-message ${messageType}`}>{message}</p>}

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={handleUpdateEventInfo}>Update Event Info</button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default EventInfoModal;
